"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectStyles = exports.customSelectStyles = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _core = require("@material-ui/core");
var _lodash = require("lodash");
var _colors = require("../../../theme/colors");
var _themeProvider = _interopRequireDefault(require("../../../theme/theme-provider"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function optionBackground(isDisabled, isSelected, isFocused, isMulti) {
  if (isMulti) {
    // intentionally blank, placeholder
  }
  if (isDisabled) {
    return _themeProvider["default"].palette.background.paper;
  }
  if (isSelected) {
    return _colors.opacity.primary[800][8];
  }
  if (!isSelected && isFocused) {
    // Return highlight style when isFocused is true.
    // This affects both :active and :hover.
    return _colors.opacity.black[8];
  }
  return null;
}

// Styles to override react-select lib's default styling
var sharedCustomStyles = {
  input: function input(provided) {
    return _objectSpread({}, provided, {
      margin: 0
    });
  },
  option: function option(provided, _ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      isMulti = _ref.isMulti;
    return _objectSpread({}, provided, {
      ':active': {
        backgroundColor: optionBackground(isDisabled, isSelected, isFocused, isMulti)
      },
      ':hover': {
        backgroundColor: optionBackground(isDisabled, isSelected, isFocused, isMulti)
      },
      backgroundColor: optionBackground(isDisabled, isSelected, isFocused, isMulti),
      height: 32,
      padding: '0px 8px'
    });
  }
};
var customSelectStyles = _objectSpread({}, sharedCustomStyles, {
  clearIndicator: function clearIndicator(provided) {
    return _objectSpread({}, provided, {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      gridArea: 'clearIndicator',
      height: 24,
      justifyContent: 'center',
      padding: 0,
      width: 24
    });
  },
  dropdownIndicator: function dropdownIndicator(provided) {
    return _objectSpread({}, provided, {
      gridArea: 'dropdownIndicator',
      left: 6,
      padding: 0
    });
  },
  group: function group(provided, _ref2) {
    var data = _ref2.data,
      _ref2$selectProps$opt = (0, _slicedToArray2["default"])(_ref2.selectProps.options, 1),
      firstOption = _ref2$selectProps$opt[0];
    var isFirstOption = (0, _lodash.isEqual)(data, firstOption);
    return _objectSpread({}, provided, {
      paddingTop: isFirstOption ? 0 : 8
    });
  },
  indicatorsContainer: function indicatorsContainer(provided) {
    return _objectSpread({}, provided, {
      columnGap: 4,
      display: 'grid',
      gridTemplateAreas: "'clearIndicator dropdownIndicator'",
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateRows: '1fr',
      justifyItems: 'center',
      marginLeft: 8,
      width: 52
    });
  },
  loadingIndicator: function loadingIndicator(provided) {
    return _objectSpread({}, provided, {
      marginRight: 0,
      padding: 0
    });
  },
  menu: function menu(provided) {
    return _objectSpread({}, provided, {
      marginTop: 0
    });
  }
});

// Applied via className/classes
exports.customSelectStyles = customSelectStyles;
var sharedStyles = function sharedStyles(theme) {
  return {
    chipWrapper: {
      padding: theme.spacing(0.25)
    },
    disabled: {},
    divider: {
      margin: 0
    },
    dropdownIndicatorHover: {
      color: theme.palette.text.primary
    },
    dropdownIndicatorRoot: {
      color: theme.palette.text.secondary
    },
    error: {},
    focused: {
      margin: '0 -1px'
    },
    focusedMulti: {
      '& > div > div': {
        paddingBottom: '1px',
        paddingTop: '1px'
      },
      margin: '0 -1px'
    },
    indicatorSeparator: {
      display: 'none'
    },
    inputComponent: {
      'label + &': {
        marginTop: 20
      },
      marginBottom: 4
    },
    inputLabel: _objectSpread({}, theme.typography.overline, {
      '&$error': {
        color: theme.palette.error.dark
      },
      color: theme.palette.text.secondary
    }),
    inputUnderlined: {
      '&$disabled:before': {
        borderBottom: 'none'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.dark
      }
    },
    multiValueContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      overflow: 'hidden',
      paddingBottom: '2px',
      paddingTop: '2px'
    },
    noOptionMessage: {
      height: 'auto',
      paddingBottom: 0,
      paddingTop: 0
    },
    placeholder: {
      color: theme.palette.text.hint,
      left: 18,
      position: 'absolute'
    },
    placeholderWithAdornment: {
      left: theme.spacing(4.75)
    },
    selected: {},
    singleValue: function singleValue(_ref3) {
      var isDisabled = _ref3.isDisabled,
        isClearable = _ref3.isClearable;
      return {
        color: isDisabled ? theme.palette.text.disabled : theme.palette.text.primary,
        left: 16,
        overflow: 'hidden',
        position: 'absolute',
        right: isClearable ? 52 : 32,
        // 52px is the width of the indicator and X in the select component, 32px for just the indicator
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      };
    },
    singleValueWithAdornment: {
      '&&': {
        left: theme.spacing(4.75)
      }
    },
    valueContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      overflow: 'hidden',
      paddingBottom: '4px',
      paddingTop: '4px'
    },
    virtualLoadingMessage: {
      color: theme.palette.text.hint,
      margin: 0,
      padding: '9.5px 0px',
      textAlign: 'center',
      width: '100%'
    }
  };
};
var useSelectStyles = (0, _core.makeStyles)(function (theme) {
  var shared = sharedStyles(theme);
  return _objectSpread({}, shared, {
    adornedStart: {
      padding: theme.spacing(0, 1)
    },
    chip: {
      margin: theme.spacing(0.25)
    },
    input: {
      borderRadius: '2px 2px 0 0',
      display: 'flex',
      height: 'auto',
      minHeight: theme.spacing(4),
      minWidth: 280,
      padding: 0
    },
    inputAdornedStart: {
      marginLeft: theme.spacing(-0.5)
    },
    multiSelectCheckbox: {
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(1)
    },
    option: {
      '& > p ': {
        '& > span:last-of-type': {
          display: 'inline-block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          verticalAlign: 'middle',
          width: function width(_ref4) {
            var isMulti = _ref4.isMulti;
            return isMulti ? 'calc(100% - 40px)' : '100%';
          }
        },
        width: '100%'
      },
      '&$disabled': {
        color: theme.palette.text.disabled,
        fontWeight: 400
      },
      '&$focused': {
        fontWeight: 400
      },
      '&$selected': {
        fontWeight: 400
      },
      '&$selected:hover': {
        background: 'none'
      },
      '&&:hover': {
        background: 'none'
      },
      boxSizing: 'content-box',
      // MaterialUI V4 fix
      color: theme.palette.text.primary,
      fontWeight: 400,
      paddingBottom: 11,
      // MaterialUI V4 fix
      paddingLeft: theme.spacing(1),
      paddingTop: 11 // MaterialUI V4 fix
    },

    paper: {
      borderRadius: '0 0 2px 2px',
      boxShadow: theme.shadows[4],
      minWidth: 280,
      paddingBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5)
    }
  });
});
exports.useSelectStyles = useSelectStyles;